<!-- src/app/components/condition-dropdown/condition-dropdown.component.html -->
<p-select class="w-full" [options]="options" [(ngModel)]="selected" (onChange)="onChange()" [showClear]="false"
    [filter]="false" optionLabel="label" dataKey="id"
    [panelStyleClass]="'shadow-lg rounded-xl overflow-hidden border border-slate-200'" [style]="{ width: 'auto' }"
    [dropdownIcon]="'pi pi-chevron-down text-slate-500'" class="diseaseDropdown">
    <!-- Selected value -->
    <ng-template pTemplate="selectedItem" let-item>
        <div class="flex items-center gap-2" style="padding: 1px 0;">
            <!-- <span class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-slate-100 text-slate-600">
                <img [src]="item?.iconSvg" alt="{{ item.iconSvg }}" class="" />
            </span> -->
            <span class="f12 font-medium">
                {{ item ? item.label : placeholder }}
            </span>
        </div>
    </ng-template>

    <!-- Dropdown list items -->
    <ng-template pTemplate="item" let-item>
        <div class="flex items-center gap-3">
            <!-- <span class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-slate-100 text-slate-600">
                <img [src]="item?.iconSvg" alt="{{ item.iconSvg }}" class="" />
            </span> -->
            <span class="f12 font-medium leading-tight">
                {{ item.label }}
            </span>
        </div>
    </ng-template>

    <!-- Empty filter (not shown since filter=false, but harmless) -->
    <ng-template pTemplate="emptyfilter">
        <div class="px-3 py-2 text-sm text-slate-500">No results found</div>
    </ng-template>
</p-select>